/*!

=========================================================
* Paper Pics React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import CrossfadeImage from 'components/CrossFade';
// import { Row, Col } from "reactstrap";	// reactstrap components


class Pics extends React.Component {

	constructor(props) {
		super(props);

		const width = 1024;
		const height = 768;

		this.state = {
			imageSrc: `https://unsplash.it/${width}/${height}?random&${new Date().getTime()}`,
			width: width,
			height: height,
		};

		this.getNewImageSrc = this.getNewImageSrc.bind(this);
	}

	componentDidMount() {
		this.getNewImageSrc();
		this.intervalNewImageSrc = setInterval(() => this.getNewImageSrc(), 10*1000);	// every 4 seconds update the thermostat value
	}

	componentWillUnmount() {
		clearInterval(this.intervalNewImageSrc);
	}

	getNewImageSrc() {
		this.setState({ imageSrc: `https://unsplash.it/${this.state.width}/${this.state.height}?random&${new Date().getTime()}` });
	}


	render() {
		return (
		  <>
			<div className="content center">
				<CrossfadeImage
					src={`${this.state.imageSrc}`}
					duration={4000}
					timingFunction={"ease-in"}
				/>
			</div>
		  </>
		);
	}
}

export default Pics;
